import { useState, useEffect } from 'react';

export default function useRecordUserSessionSinceCalled(isActive: boolean) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!isActive) return;

    const interval = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds + 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [isActive]); // Se ejecutará nuevamente si isActive cambia

  return seconds;
}
